// SocketNotificationHandler.tsx - Optimized
import React, { useEffect } from 'react';
import { useSocket } from './SocketContext';
import { useNotifications } from './NotificationContext';

const SocketNotificationHandler: React.FC = () => {
    const { socket, isConnected } = useSocket();
    const { addNotification, fetchNotifications } = useNotifications();

    useEffect(() => {
        if (!socket || !isConnected) {
            console.log("⏳ Waiting for socket connection...");
            return;
        }

        console.log("✅ Socket connected, setting up notification listener");

        const handleNewNotification = (notification: any) => {
            console.log("🔔 IMMEDIATE notification received:", notification);

            // Process immediately
            addNotification(notification);

            // Optional: Play notification sound
            if (Notification.permission === "granted") {
                new Notification("New Notification", {
                    body: notification.message?.replace(/<[^>]*>/g, '').substring(0, 100)
                });
            }
        };

        // Remove any existing listeners first
        socket.off("new-notification");

        // Add new listener
        socket.on("new-notification", handleNewNotification);

        // Also handle initial connection
        socket.on("connect", () => {
            console.log("🔗 Socket connected, fetching fresh notifications");
            fetchNotifications();
        });

        return () => {
            console.log("🧹 Cleaning up socket handlers");
            socket.off("new-notification", handleNewNotification);
            socket.off("connect");
        };
    }, [socket, isConnected, addNotification, fetchNotifications]);

    return null;
};

export default SocketNotificationHandler;